import { render, staticRenderFns } from "./TopUser.vue?vue&type=template&id=57705578"
import script from "./TopUser.vue?vue&type=script&lang=ts"
export * from "./TopUser.vue?vue&type=script&lang=ts"
import style0 from "./TopUser.vue?vue&type=style&index=0&id=57705578&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports